<div id="main-text">
  <h1 style="text-align: center">STIC Galaxy</h1>
  <p style="text-align: center">
    Navigate through past and ongoing research projects in an interactive galaxy visualization. Discover connections
    cross domains, technologies, and teams.
  </p>
</div>

<app-chat-view></app-chat-view>
<app-graph-dashboard></app-graph-dashboard>
